export default __webpack_public_path__ + "static/media/surveyCircle.511b1a5a.png";